import { Camera, Layers, ShieldCheck } from 'lucide-react';
import { Gallery } from '../components/Gallery';
import { Reveal } from '../components/Reveal';
import { gallery } from '../data/content';

export function GalleryPage() {
  const totalCount = gallery.length;
  const categoriesCount = new Set(gallery.map((item) => item.category)).size;

  return (
    <>
      <section className="gallery-hero">
        <div className="shell gallery-hero__grid">
          <Reveal>
            <div className="gallery-hero__left">
              <div className="gallery-hero__kicker">
                <span className="gallery-hero__kicker-dot" />
                <span className="gallery-hero__kicker-label font-display">Acervo Visual Oficial</span>
                <span className="gallery-hero__kicker-tag font-display">Traiano 55789</span>
              </div>
              <h1 className="gallery-hero__title font-display">
                Registros de <span className="gallery-hero__title-accent">Palmas.</span>
              </h1>
            </div>
          </Reveal>

          <Reveal delay={0.08}>
            <div className="gallery-hero__right">
              <p className="gallery-hero__desc font-body">
                Obras, equipamentos públicos e espaços transformados apresentados em alta resolução, organizados por tema e impacto no município.
              </p>

              <div className="gallery-hero__badges">
                <div className="gallery-hero__badge">
                  <Camera />
                  <span><strong>{totalCount}</strong> Registros em Alta Definição</span>
                </div>
                <div className="gallery-hero__badge">
                  <Layers />
                  <span><strong>{categoriesCount}</strong> Categorias Temáticas</span>
                </div>
              </div>

              <div className="gallery-hero__disclaimer">
                <ShieldCheck />
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="gallery-page shell">
        <Reveal>
          <Gallery />
        </Reveal>
      </section>
    </>
  );
}
